import NumberFormattingService from 'client/services/number-formatting-service';

const moneyFormat = x => {
  return typeof x === 'number' ? NumberFormattingService.formatNumberAsCurrency(x) : '';
};

export default moneyFormat;
